import { RootState } from 'PROCUREMENTTypes';
import { ProductsListReducerState } from '@cp/redux/reducers/productsList';

export const getProductsList = (state: RootState): ProductsListReducerState =>
  state.productsList;
